const Root = Symbol("ParentAssigner.Root");

class ParentAssigner {
    link(parent, child) {
        throw new Error("Method .link is not implemented");
    }

    unlink(parent, child) {
        throw new Error("Method .unlink is not implemented");
    }
}

ParentAssigner.Root = Root;

export default ParentAssigner;
export { ParentAssigner, Root };
